const util =  {
  handletag(ids=[], type="get"){
    let taglist = [];
    switch(type)
    {
      case 'set':
        for(let i = 0; i < ids.length; i++)
        {
          if(ids[i].tag){
               ids[i].color = this.userColor(ids[i].tag, i)
          }
        }
        tags = ids;
        break;
      case 'get':
        if(ids.length == 0){
          tags.filter(function (el) {el.select=false })
           
          taglist = tags;
        }
        else
        {
          for(let i = 0; i < ids.length; i++)
          {
            taglist.push(tags[tags.map(e=>e._id).indexOf(ids[i])]);
          }
        }
        break;
        default:
        break;
    }
    taglist.sort(function(a, b) { 
      const nameA = a.tag.toLowerCase().trim(),
        nameB = b.tag.toLowerCase().trim();
      if (nameA < nameB){
        //sort string ascending
        return -1;
        return 0;
      }
    });
     return taglist;
   },
    formatPhoneNumber(phoneNumber) {
        if (!phoneNumber) {
            return null;
        }
        if (typeof phoneNumber === 'number') {
            phoneNumber = phoneNumber.toString();
        }
        phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/);
        const re = /(?:1)?(\d{3})(\d{3})(\d{4})/;
        const matches = phoneNumber.match(re);
        if (matches === null) {
            return phoneNumber;
        }
        return `${matches[1]}-${matches[2]}-${matches[3]}`;
    },

    validatePhoneNumber(phoneNumber: any) {
        if(!phoneNumber) {
          return false;
        }
        if(typeof phoneNumber === "number") {
          phoneNumber = phoneNumber.toString();
        }
        //strip all potential nondigits
        phoneNumber = phoneNumber.replace(/\(/g, '').replace(/\)/g, '').replace(/ /g, '').replace(/-/g, '').replace(/\+/, '');
          if(!(/[1-9]{1}[0-9]{9}/.test(phoneNumber)))
            {
                return false;
            }
        //Allow US country code if supplied
        const re = /^1?\d{10}$/;
        if(!re.test(phoneNumber)) {
          return false;
       }
        return true;
      },

      validateEmail(email: any) {
        //Breakdown of this Regex can be found here:
        //https://www.w3resource.com/javascript/form/email-validation.php
        //Seems to cover most all cases.
          const re =/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;// /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if(!re.test(email)) {
                return false;
            }
        return true;
      },

    

    timeZone :[
        {value: 'America/New_York', text:'Eastern Time, ET, New York, NY'}, 
        {value: 'America/Chicago', text:'Central Time, CT, Chicago, IL'}, 
        {value: 'America/Denver', text:'Mountain Time, MT, Denver, CO'},
        {value: 'America/Phoenix', text:'Mountain Standard Time, MST, Phoenix, AZ'},  
        {value: 'America/Los_Angeles', text:'Pacific Time, PT, Los Angeles, CA'},  
        {value: 'America/Anchorage', text:'Alaska Time, AKT, Anchorage, AK'},    
        {value: 'Pacific/Honolulu', text: 'Hawaii Standard Time, HST, Honolulu, HI'},                                              
        // {value: 'America/Anchorage', text: 'America/Anchorage'}     
],

   
    timeArr()
    {
        let timeArr = [];
        for(let i = 0; i <= 1410; i+=30)
        {
            let text = '';
            let shownText = '';
            let savedValue = { hh: "12", mm: "00", ss: "00", a: "am" };
            if(i < 60)
            {
                text = '00:'+("0" + i).slice(-2);
            }
            else
            {
                if(i%60 == 0)
                {
                    text = ("0" + (i/60)).slice(-2)+":00";
                }
                else
                {
                    let min = i%60;
                    let hour = i - min;
                    hour = hour/60;
                    text = (("0" + hour).slice(-2))+":"+ (("0" + min).slice(-2));
                }
            }
            let text_arr = text.split(":");
            if(parseInt(text_arr[0]) <= 12) 
            {
                shownText = (parseInt(text_arr[0]) == 0) ? "12:" + text_arr[1] + " AM" : text + ((parseInt(text_arr[0]) == 12) ? " PM" : " AM");
                savedValue = { hh: ("0" + text_arr[0]).slice(-2), mm:  ("0" + text_arr[1]).slice(-2), ss: "00", a: ((parseInt(text_arr[0]) == 12) ? "pm" : "am") };

            }
            else 
            {
                shownText = (("0" + (parseInt(text_arr[0]) - 12)).slice(-2))+":"+ (("0" + text_arr[1]).slice(-2)) + " PM";
                savedValue = { hh: ("0" + (parseInt(text_arr[0]) - 12)).slice(-2), mm:  ("0" + text_arr[1]).slice(-2), ss: "00", a: "pm" };
            }
            timeArr.push({min_count: i, round_text: text, hour_text: shownText, full_value: savedValue});
        }
        return timeArr;
    },

    formaReportTime(momentTZ,value)
    {
        const duration = momentTZ.duration(+value, 'seconds');
        const dt= momentTZ.utc(duration.asMilliseconds());
        const minutes= dt.format("m");
        const sconds=dt.format("s");
        if (minutes>0)
            return `${minutes}m ${sconds}s`;
        else
            return `${sconds}s`;
    },
    getcolorindex(colorindexlist)
    {
         const reservarray= [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14];
         var intcolorindexlist= colorindexlist.filter(y=>y || y===0).map(x=> parseInt(x));
        const available_index  = reservarray.filter(function(item) {
                 return !intcolorindexlist.includes(item); 
                    });
        return available_index.length>0? available_index[0]:Math.floor(Math.random() * 14);
    },
    getNotifyColor(index)
    {
       var colors =[[103, 59, 184, 1],[205, 220, 57, 1],[1, 150, 136, 1],[4, 169, 245, 1],
        [255, 235, 60, 1],[123, 123, 123, 1],[156, 40, 177, 1]
        ,[102, 188, 0, 1],[245, 128, 55, 1],[48, 60, 128, 1],[254, 193, 7, 1],
        [65, 150, 68, 1],[206, 16, 16, 1],[235, 131, 231, 1], ,[232, 30, 98, 1]];
       
      var x = colors[index];
      if (!x )
      {
            index= Math.floor(Math.random() * 15);
            x = colors[index];
      }
        let  c = 1;
        let  g = 1;
        let  b = 1;
        let  a = 1;
        if(x.length == 4)
        {
            c = x[0];
            g = x[1];
            b = x[2];
            a = x[3];
        }
       
        return `rgb(${c}, ${g}, ${b})`;
    },

    
    randomcolor2(user)
    {
        if (user)
        {
            var usercolorindex=user.colorindex || user.colorindex===0?user.colorindex:-1;
            var usercolor= user&& user.usercolor? user.usercolor: util.getNotifyColor(usercolorindex);
            user.usercolor=usercolor;
            return usercolor;
        }
        else
            return util.getNotifyColor(13);
    },
      
    userColor(key, i)
    {
        
        const colors =[[103, 59, 184, 1],[255, 193, 7, 1],[1, 150, 136, 1],[4, 169, 245, 1],
        [123, 123, 123, 1],[156, 40, 177, 1]
        ,[102, 188, 0, 1],[245, 128, 55, 1],[48, 60, 128, 1],[254, 193, 7, 1],
        [65, 150, 68, 1],[206, 16, 16, 1],[235, 131, 231, 1], ,[232, 30, 98, 1]];
        // if(!key) return `rgb(${colors[0][0]}, ${colors[0][1]}, ${colors[0][2]})`; 
        key = key.trim();
        let  c = 1;
        let  g = 1;
        let  b = 1;
        let  a = 1;
        let index = 0;
        if(usercolor_list.map(e=>e.username).indexOf(key)== -1)
        {
          if(i < 14)
          {
            index = i;
          }
          else
          {
            let j = index = Math.floor(Math.random() * 13);
            index = j < 14 ? j : 0;
          }
            
            usercolor_list.push({color_index : index,username :key});
            
        }
        else{
             index = usercolor_list.map(e=>e.username).indexOf(key) ;
        }
      //  console.log(usercolor_list)
     //   console.log("-------------------");
     //   console.log(index);
        let color = colors[index] ? colors[index] : colors[0];
     //   console.log(color);
          c = color[0];
          g = color[1];
          b = color[2];
          a = color[3];
        return `rgb(${c}, ${g}, ${b})`;
    },
    randomColor(key,isafter,self) {
       
        if(!isafter) 
          return `rgba(149, 152, 154, 1)`;
        else
        {
              var user = (self as any).users.find(u=>u.id===key || u.kazooid===key);
              var usercolorindex=user && user.masteruser ? user.colorindex:-1;
              if (user)
              {
                   var userproperty;
                  if (!user.msteruser &&  user.propertylist)
                  {
                         userproperty= user.propertylist.find (up=>up.id===(self as any).property_id );
                        usercolorindex=userproperty ? userproperty.colorindex:-1;
                  }
                  else if (user.msteruser)
                  {
                      usercolorindex=user.colorindex? user.colorindex:-1;
                  }
                  usercolorindex= parseInt(usercolorindex);
                  if (usercolorindex===-1 || (!usercolorindex &&usercolorindex!=0 ))
                  {
                           const property_users= (self as any).users.filter(u=>u.propertylist);
                           var propertylist= property_users.map (pl=>pl.propertylist);
                           var upropertylist=[];
                           propertylist.forEach(p => {
                             var up= p.find(pp=>pp.id===(self as any).property_id);
                             if (up)
                             {
                                upropertylist.push(up);
                             }
                           });
                         //  propertylist= propertylist.fil
                           var propertycolorindexlist=upropertylist.map(p1=>
                                                     p1.colorindex);
                          var masterusercolorindexlist= (self as any).users.map(u=>u.colorindex);
                           var colorindexlist = propertycolorindexlist.concat(masterusercolorindexlist);
                           usercolorindex=util.getcolorindex(colorindexlist);
                           if (userproperty)
                           {
                                userproperty.colorindex=usercolorindex;
                           }
                           else
                           {
                                user.colorindex=usercolorindex;
                           }
                            colorindexlist.push(usercolorindex);
                            const payload= {
                              companyid:(self as any).selectedcompanyid,
                              propertyid:(self as any).property_id,
                              userid:user.id,
                              colorindex:usercolorindex
                            }
                            self.$store.dispatch("notifyusercolorindexsave", payload)
                  }
              }

              var usercolor= user&& user.usercolor? user.usercolor: util.getNotifyColor(usercolorindex);
              if (user)
                user.usercolor=usercolor;
              else
                usercolor= util.getNotifyColor(13);
              return usercolor;
        }
      
      }
      
};
var usercolor_list =[];
var tags = [];
export default util;
